import { render, staticRenderFns } from "./KanbanItem.vue?vue&type=template&id=6433d4aa&scoped=true&"
import script from "./KanbanItem.vue?vue&type=script&lang=ts&"
export * from "./KanbanItem.vue?vue&type=script&lang=ts&"
import style0 from "./KanbanItem.vue?vue&type=style&index=0&id=6433d4aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6433d4aa",
  null
  
)

export default component.exports